import React, { useState } from "react";
import RegistrationInputs from "../../Inputs/RegistrationInputs/RegistrationInputs";
import LiginImage from "../../../Images/Login.jpg";
import { Link } from "react-router-dom";
export default function Signin() {
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  function handleInputs(e) {
    setUser({ ...user, [e.target.id]: e.target.value });
  }
  return (
    <>
      <div className="container-fluid vh-100 d-flex justify-content-center align-items-center">
        <div className="row justify-content-center align-items-center">
          <figure className="col-12 col-md-6 d-xxl-block d-md-block d-sm-none d-none ">
            <div className="m-3 position-relative">
              <div className="position-absolute start-0 end-0 top-0 bottom-0 layer"></div>
              <img
                src={LiginImage}
                alt="Login"
                className=""
                style={{ borderRadius: "10px" }}
              />
            </div>
          </figure>
          <div className="col-12 col-md-6 ">
            <div className="m-3 d-flex justify-content-center align-items-center flex-column">
              <h1 className="text-center w-100"> تسجيل الدخول </h1>
              <RegistrationInputs Signin={false} handleinputs={handleInputs} />
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
